<template>
    <van-button v-if="visible" class="back-to-top" icon="arrow-up" type="primary" circle size="mini"
        @click="scrollToTop" />
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";

const props = defineProps({
    scrollThreshold: { type: Number, default: 200 }, // 滚动多少显示
});

const visible = ref(false);

const onScroll = () => {
    visible.value = window.scrollY > props.scrollThreshold;
};

// 平滑回到顶部
const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
};

onMounted(() => {
    window.addEventListener("scroll", onScroll);
});

onUnmounted(() => {
    window.removeEventListener("scroll", onScroll);
});
</script>

<style scoped>
.back-to-top {
    position: fixed;
    bottom: 100px;
    /* 可以改为 props.bottom */
    right: 20px;
    /* 可以改为 props.right */
    z-index: 999;
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    background-color: #2969ff;
    cursor: pointer;
    border: none;
}
</style>